import { render, staticRenderFns } from "./JourneyStory.vue?vue&type=template&id=1ea35402&scoped=true"
import script from "./JourneyStory.vue?vue&type=script&lang=js"
export * from "./JourneyStory.vue?vue&type=script&lang=js"
import style0 from "./JourneyStory.vue?vue&type=style&index=0&id=1ea35402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea35402",
  null
  
)

export default component.exports